/* ====================================================================
   DANDY — HOMEPAGE STORY LINK + PHOTO SLOTS  (assets/dpc-story-cta.js)
   Two jobs on the homepage:
     1. "Preview the Collection" link in the "From the studio" section,
        pointing at the story modal's URL /pages/fall-native?story=1
     2. Fills the labelled PHOTO placeholder slots with real photography

   ------------------------------------------------------------------
   THE PHOTO MAP — THIS IS THE ONLY THING YOU EDIT TO ADD A PHOTO.
   Left = a distinctive fragment of the placeholder's visible label, matched
   case-insensitively. Right = the asset filename exactly as it appears under
   Assets. A slot with no entry keeps its placeholder, so partial photography
   is fine — nothing breaks.

   >>> COMMAS AND SLASHES IN A FILENAME BREAK THE UPLOAD, SILENTLY. <<<
   Proven twice. The first batch of eleven photos was named after the slot
   labels and only three arrived — the three with no comma. Shopify reports no
   error; the file simply is not in Assets. Re-uploaded without commas, all
   eleven landed. Keep names lowercase-ish, no commas, no slashes.

   NOTE THE LABELS STILL CONTAIN COMMAS — that is fine and expected. The
   match fragments below are label text, not filenames.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  if (!document.body || document.body.className.indexOf('template-index') === -1) return;

  /* label fragment  ->  asset filename */
  var PHOTOS = [
    ['studio table, materials laid out',   'Studio table materials laid out.jpeg'],
    ['hands wrapping a wreath base',       'Hands wrapping a wreath base.jpeg'],
    ['floral artist at the studio table',  'Floral artist at the studio table.jpeg'],
    ['building a wreath, close crop',      'Building a wreath close crop.jpeg'],
    ['full entry, wide shot',              'Frontentrywide.jpeg'],
    ['wreath on the door, detail',         'Wreath on the door detail.jpeg'],
    ['mums and pumpkins on the steps',     'Mums and pumpkins on the steps.jpeg'],
    ['floral arch, installed photo',       'Floral arch installed photo.jpeg'],
    ['storefront entry',                   'Storefront entry coffee .jpg'],
    ['refreshed planters',                 'Refreshed planters on-porch photo.jpeg']

    /* "Annual Membership, styled porch photo" has no file yet.
       UNASSIGNED but present: dried_florals_loose.jpeg,
       poplar_basket_weave.jpeg, rust_velvet_ribbon.jpeg (texture details),
       IMG_9768.jpeg and IMG_9780 2.jpeg (uncompressed camera originals). */
  ];

  var LABEL = 'Preview the Collection \u2192';
  var HEAD = /how our fall collection came together/i;
  var MARK = 'dpc-story-cta';
  var FILLED = 'dpc-slot-filled';
  var DEADLINE = Date.now() + 12000;

  function norm(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function assetUrl(name) {
    /* Derive the CDN base from an asset the page already loads, so this needs
       no Liquid and survives a shop or theme id change. Filenames contain
       spaces, so each segment must be encoded. */
    var s = document.querySelector('link[href*="/assets/"], script[src*="/assets/"]');
    var href = s ? (s.href || s.src) : '';
    var base = href.split('/assets/')[0];
    if (!base) return null;
    return base + '/assets/' + encodeURIComponent(name);
  }

  /* Replace a placeholder's text with an <img> filling the existing frame.
     The parent already sets aspect-ratio, radius and overflow:hidden, so the
     image only has to cover it. */
  function fillSlots() {
    var els = document.querySelectorAll('div,span,p');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;
      if (el.className && String(el.className).indexOf(FILLED) > -1) continue;
      var t = norm(el);
      if (!/^photo\s*[\u2014-]/i.test(t)) continue;

      var lower = t.toLowerCase();
      for (var p = 0; p < PHOTOS.length; p++) {
        if (lower.indexOf(PHOTOS[p][0]) === -1) continue;
        var url = assetUrl(PHOTOS[p][1]);
        if (!url) break;

        var img = document.createElement('img');
        img.src = url;
        img.alt = t.replace(/^photo\s*[\u2014-]\s*/i, '');
        img.loading = 'lazy';
        img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';

        el.textContent = '';
        el.className = (el.className ? el.className + ' ' : '') + FILLED;
        el.style.padding = '0';
        el.appendChild(img);
        break;
      }
    }
  }

  function placeLink() {
    var existing = document.querySelector('.' + MARK);
    if (existing) {
      if (norm(existing) !== LABEL) existing.textContent = LABEL;
      return true;
    }

    var els = document.querySelectorAll('h1,h2,h3,h4,p,span,div');
    var head = null;
    for (var i = 0; i < els.length; i++) {
      if (els[i].children.length) continue;
      if (HEAD.test(norm(els[i]))) { head = els[i]; break; }
    }
    if (!head) return false;

    /* Climb to the text column. Measured on NORMALISED text — raw textContent
       is mostly whitespace, and comparing raw length against a small bound is
       what silently broke five earlier attempts elsewhere in this codebase. */
    var col = head.parentElement;
    for (var up = 0; up < 5 && col; up++) {
      var t = norm(col);
      if (t.length > 900) { col = null; break; }
      if (/first look/i.test(t)) break;
      col = col.parentElement;
    }
    if (!col) col = head.parentElement;
    if (!col) return false;

    var a = document.createElement('a');
    a.className = MARK;
    a.href = '/pages/fall-native?story=1';
    a.textContent = LABEL;
    a.style.cssText = [
      'display:inline-block','margin-top:22px',
      'font-family:Mulish,system-ui,sans-serif','font-size:15px','font-weight:600',
      'letter-spacing:.01em','color:#C9A24B','text-decoration:none',
      'border-bottom:1px solid rgba(201,162,75,.45)','padding-bottom:3px'
    ].join(';');
    a.addEventListener('mouseenter', function () { a.style.borderBottomColor = '#C9A24B'; });
    a.addEventListener('mouseleave', function () { a.style.borderBottomColor = 'rgba(201,162,75,.45)'; });
    col.appendChild(a);
    return true;
  }

  function run() {
    fillSlots();
    return placeLink();
  }

  if (run()) return;
  var timer = setInterval(function () {
    if (run() || Date.now() > DEADLINE) clearInterval(timer);
  }, 400);
})();
